import { useEffect, FunctionComponent, useState } from 'react';
import useFetchBillPayTransaction from '@/hooks/useApi/useFetchBillPayTransaction';
import BillPayInfo from './BillPayInfo';

type TransactionProps = {
  TransactionID: string;
  jwt: string;
};
type FC = FunctionComponent<TransactionProps>;

const BillPayContainer: FC = (props: TransactionProps) => {
  const { TransactionID, jwt } = props;
  const { fetchBillPayTransaction, details } = useFetchBillPayTransaction({ bearer: jwt });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();

  useEffect(() => {
    fetchBillPayTransaction({
      TransactionID: TransactionID,
    });
  }, [currentTransactionId]);

  useEffect(() => {
    if (currentTransactionId !== TransactionID) {
      setCurrentTransactionId(TransactionID);
    }
  }, [TransactionID, currentTransactionId]);

  return <div>{details && <BillPayInfo transaction={details} jwt={jwt} />}</div>;
};

export default BillPayContainer;
